module.exports = __webpack_public_path__ + "static/40-911a9a150acb5d3e18b1ee8eda51511c.png";